import { types } from '../actions/CurrentSlideActions';
import shapeTypes from '../constants/ShapeConstants';
import modeType from '../constants/ModeConstants';
import appParameters from '../components/utils/AppParameters';
import uuid from 'uuid';
import storeManager from '../store/StoreManager';
import moodsUtils from '../components/utils/MoodsUtils';
import configuration from '../constants/Configuration';
import selectionManager from '../components/utils/SelectionManager';
import audioUtils from '../components/utils/AudioUtils';
import animationManager from '../components/utils/AnimationManager';
import bubbleUtils from '../components/slide/shapes/utils/BubblesUtils';
import createShapes from '../components/utils/CreateShapes';
import textEditorUtils from '../components/menus/textEditorTool/utils/TextEditorUtils';
import properties from "../constants/Properties";

function getContent(state, uuid) {
    let clone = animationManager.getCloneByUid(uuid);

    if (animationManager.clone && clone)
        return [clone];

    if (animationManager.clone && animationManager.clone.uuid == uuid)
        return [animationManager.clone];
    else
        return state.model.content;
}

export function animate(state, shapes, animations) {
    const newContent = state.model.content.map(shape => {
        if (shapes.indexOf(shape.uuid) != -1) {
            const newShape = Object.assign({}, shape);
            var animation = animations[shape.uuid];

            if (shape.type == shapeTypes.LINE || shape.type == shapeTypes.CURVE) {
                if (animation.x1)
                    newShape.x1 = animation.x1;

                if (animation.y1)
                    newShape.y1 = animation.y1;

                if (animation.x2)
                    newShape.x2 = animation.x2;

                if (animation.y2)
                    newShape.y2 = animation.y2;

                if (shape.type == shapeTypes.CURVE) {
                    if (animation.cx)
                        newShape.cx = animation.cx;

                    if (animation.cy)
                        newShape.cy = animation.cy;
                }
            } else {
                if (animation.x)
                    newShape.x = animation.x;

                if (animation.y)
                    newShape.y = animation.y;

                var oldWidth = newShape.width;
                var oldHeight = newShape.height;

                if (animationManager.isScaleAnimation(newShape)) {
                    if (animation.width)
                        newShape.animationWidth = animation.width;

                    if (animation.height)
                        newShape.animationHeight = animation.height;
                } else {
                    if (animation.width)
                        newShape.width = animation.width;

                    if (animation.height)
                        newShape.height = animation.height;
                }

                if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                    if (animation.cx)
                        newShape.cx = animation.cx;

                    if (animation.cy)
                        newShape.cy = animation.cy;

                    if (animation.cx1)
                        newShape.cx1 = animation.cx1;

                    if (animation.cy1)
                        newShape.cy1 = animation.cy1;

                    if (animation.cx2)
                        newShape.cx2 = animation.cx2;

                    if (animation.cy2)
                        newShape.cy2 = animation.cy2;

                    if (animation.cx3)
                        newShape.cx3 = animation.cx3;

                    if (animation.cy3)
                        newShape.cy3 = animation.cy3;

                    if (animation.cx4)
                        newShape.cx4 = animation.cx4;

                    if (animation.cy4)
                        newShape.cy4 = animation.cy4;

                    if (animation.cx5)
                        newShape.cx5 = animation.cx5;

                    if (animation.cy5)
                        newShape.cy5 = animation.cy5;
                }

                if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.TEXTBOX || shape.type == shapeTypes.TEXTBOXSIMPLE)
                    newShape.fontSize = animation.fontSize;
                else if (shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                    if (!animationManager.isScaleAnimation(shape))
                        newShape.fontSize = animation.fontSize;
                }

                if (newShape.type == shapeTypes.GROUP)
                    updateGroupShapesSize(newShape, oldWidth, newShape.width, oldHeight, newShape.height, false);
            }

            if (animation.opacity >= 0)
                newShape.opacity = animation.opacity;

            if (animation.rotation >= 0)
                newShape.rotation = animation.rotation;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function removeAnimation(state, uuid) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.animation = undefined;
            newShape.opacity = 1.0;
            newShape.rotation = 0;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function addAnimation(state, uuid, animation) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            if (!animation) {
                newShape.animation = undefined;
                return newShape;
            }

            if (!(animation.start_opacity >= 0))
                animation.start_opacity = 1;

            if (!(animation.end_opacity >= 0))
                animation.end_opacity = 1;

            if (!(animation.start_rotation >= 0))
                animation.start_rotation = 0;

            if (!(animation.end_rotation >= 0))
                animation.end_rotation = 0;

            newShape.animation = animation;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeShapeOpacity (state, shapeModel, opacity) {
    let clone = animationManager.getCloneByUid(shapeModel.uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && shapeModel.uuid === clone.uuid) {
        const newShape = Object.assign({}, clone);
        newShape.opacity = opacity;

        animationManager.replaceClone(newShape);
    }

    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            newShape.opacity = opacity;

            if (newShape.animation)
                setAnimationStartProperties(newShape);

            if (animationManager.target && newShape.uuid === animationManager.target.uuid)
                animationManager.target = newShape;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function updateShapeRotation (state, uuid, newRotation) {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            if (newRotation < 0)
                newRotation = 360 + newRotation;

            newShape.rotation = newRotation;

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            } else {
                if (newShape.animation)
                    setAnimationStartProperties(newShape);
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function generateNewPathPoints(pathPoints, oldWidth, newWidth, oldHeight, newHeight) {
    let i;
    const length = pathPoints.length;
    let newPathPoints = [];

    for (i=0; i<length; i++) {
        newPathPoints.push({x: pathPoints[i].x * newWidth / oldWidth, y: pathPoints[i].y * newHeight / oldHeight});
    }

    return newPathPoints;
}

function updateCurrentSlideMoods(state) {
    const newContent = state.model.content.map(shape => {
        if (shape.type === shapeTypes.BACKGROUND || shape.type == shapeTypes.CHARACTER) {
            const newShape = Object.assign({}, shape);
            newShape.moods = moodsUtils.getMoods(newShape.logicalName);

            if (newShape.type == shapeTypes.BACKGROUND && newShape.moods && newShape.moods.length > 0) {
                if (newShape.logicalName != undefined && newShape.logicalName.length > 0 && (newShape.frameLabel == undefined || newShape.frameLabel.length < 1))
                    newShape.frameLabel = 'dag';
                    newShape.xlinkHref = appParameters.SVG_URL() + `${newShape.logicalName}_${newShape.frameLabel}.svg`;
                    newShape.hotSpot = '';
            }

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateHotspot(state, uuid, hotspot) {
    const newContent = state.model.content.map(shape => {
        if (shape.type === shapeTypes.BACKGROUND && shape.uuid == uuid) {
            const newShape = Object.assign({}, shape);

            newShape.hotSpot = hotspot;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function insertImageNode(state, uuid, href, aspectRatio) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid == uuid) {
            const newShape = Object.assign({}, shape);

            let imageHeight = shape.height - 2 * properties.TEXT_INNER_PADDING;
            let imageWidth;
            let newShapeWidth;

            if (shape.imageNode && shape.imageNode.length > 0) { // the shape already has an image node
                imageWidth = imageHeight * shape.aspectRatio;
                newShapeWidth = shape.width - imageWidth - properties.TEXT_INNER_PADDING; // the shape width after removing image

                if (href && href.length > 0) { // replace the shape
                    imageWidth = imageHeight * aspectRatio; // new image width
                    newShapeWidth = newShapeWidth + imageWidth + properties.TEXT_INNER_PADDING; // resize width after adding the new image
                }
            } else {
                imageWidth = imageHeight * aspectRatio;
                newShapeWidth = shape.width + imageWidth + properties.TEXT_INNER_PADDING;
            }

            newShape.width = newShapeWidth;
            newShape.imageNode = href;
            newShape.aspectRatio = aspectRatio;

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeFlip(state, uuid, flipType) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid == uuid) {
            const newShape = Object.assign({}, shape);

            if (flipType == 'horizontalFlip') {
                if (!newShape.horizontalFlip || newShape.horizontalFlip == 1)
                    newShape.horizontalFlip = -1;
                else
                    newShape.horizontalFlip = 1;
            } else {
                if (!newShape.verticalFlip || newShape.verticalFlip == 1)
                    newShape.verticalFlip = -1;
                else
                    newShape.verticalFlip = 1;
            }

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateCroppingHotspot(state, uuid, hotspot) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid == uuid) {
            const newShape = Object.assign({}, shape);
            var x1, x2, y1, y2;

            if (newShape.hotSpot != undefined && newShape.hotSpot != '') { // update hotspot for a shape with already hotspot
                var realWidth = shape.width * 100 / (shape.hotSpot.x2 - shape.hotSpot.x1);
                var realHeight = shape.height * 100 / (shape.hotSpot.y2 - shape.hotSpot.y1);

                x1 = realWidth * shape.hotSpot.x1 / 100;
                y1 = realHeight * shape.hotSpot.y1 / 100;
                x2 = realWidth * shape.hotSpot.x2 / 100;
                y2 = realHeight * shape.hotSpot.y2 / 100;

                var realShapeSize = {};
                realShapeSize.width = realWidth;
                realShapeSize.height = realHeight;
                realShapeSize.x = shape.x - x1;
                realShapeSize.y = shape.y - y1;

                if (hotspot == '') { // remove hotspot
                    newShape.x = realShapeSize.x;
                    newShape.y = realShapeSize.y;
                    newShape.width = realShapeSize.width;
                    newShape.height = realShapeSize.height;
                    newShape.hotSpot = '';

                    newShape.isCropAndFlipHorizontal = false;
                    newShape.isCropAndFlipVertical = false;
                } else { // add a new hotspot
                    newShape.hotSpot = hotspot;

                    x1 = realShapeSize.width * hotspot.x1 / 100;
                    y1 = realShapeSize.height * hotspot.y1 / 100;
                    x2 = realShapeSize.width * hotspot.x2 / 100;
                    y2 = realShapeSize.height * hotspot.y2 / 100;

                    newShape.x = realShapeSize.x + x1;
                    newShape.y = realShapeSize.y + y1;
                    newShape.width = x2 - x1;
                    newShape.height = y2 - y1;

                    if (newShape.horizontalFlip == -1)
                        newShape.isCropAndFlipHorizontal = true;
                    else
                        newShape.isCropAndFlipHorizontal = false;

                    if (newShape.verticalFlip == -1)
                        newShape.isCropAndFlipVertical = true;
                    else
                        newShape.isCropAndFlipVertical = false;
                }
            } else { // add hotspot first time for the original shape
                if (hotspot == '')
                    newShape.hotSpot = '';
                else {
                    newShape.hotSpot = hotspot;

                    var x1 = shape.width * hotspot.x1 / 100;
                    var y1 = shape.height * hotspot.y1 / 100;
                    var x2 = shape.width * hotspot.x2 / 100;
                    var y2 = shape.height * hotspot.y2 / 100;

                    newShape.x = shape.x + x1;
                    newShape.y = shape.y + y1;
                    newShape.width = x2 - x1;
                    newShape.height = y2 - y1;

                    if (newShape.horizontalFlip == -1)
                        newShape.isCropAndFlipHorizontal = true;
                    else
                        newShape.isCropAndFlipHorizontal = false;

                    if (newShape.verticalFlip == -1)
                        newShape.isCropAndFlipVertical = true;
                    else
                        newShape.isCropAndFlipVertical = false;
                }
            }
            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateGroupShapesSize (shapeGroup, oldWidth, newWidth, oldHeight, newHeight, updatePath = true) {
    var i;
    var shape;
    var shapes = shapeGroup.shapes;
    var newGroupedShapes = [];
    var widthScale = newWidth / oldWidth;
    var heightScale = newHeight / oldHeight;

    for (i=0; i<shapes.length; i++) {
        shape = Object.assign({}, shapes[i]);

        switch (shape.type) {
            case shapeTypes.LINE: {
                shape.x1 = shape.x1 * widthScale;
                shape.y1 = shape.y1 * heightScale;
                shape.x2 = shape.x2 * widthScale;
                shape.y2 = shape.y2 * heightScale;
                break;
            }

            case shapeTypes.CURVE: {
                shape.x1 = shape.x1 * widthScale;
                shape.y1 = shape.y1 * heightScale;
                shape.x2 = shape.x2 * widthScale;
                shape.y2 = shape.y2 * heightScale;
                shape.cx = shape.cx * widthScale;
                shape.cy = shape.cy * heightScale;
                break;
            }

            default: {
                var oldW = shape.width;
                var oldH = shape.height;

                shape.x = shape.x * widthScale;
                shape.y = shape.y * heightScale;
                shape.width = shape.width * widthScale;
                shape.height = shape.height * heightScale;

                if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                    shape.cx = shape.cx * widthScale;
                    shape.cy = shape.cy * heightScale;

                    if (shape.cx1) {
                        shape.cx1 = shape.cx1 * widthScale;
                        shape.cy1 = shape.cy1 * heightScale;
                    }

                    if (shape.cx2) {
                        shape.cx2 = shape.cx2 * widthScale;
                        shape.cy2 = shape.cy2 * heightScale;
                    }

                    if (shape.cx3) {
                        shape.cx3 = shape.cx3 * widthScale;
                        shape.cy3 = shape.cy3 * heightScale;
                    }

                    if (shape.cx4) {
                        shape.cx4 = shape.cx4 * widthScale;
                        shape.cy4 = shape.cy4 * heightScale;
                    }

                    if (shape.cx5) {
                        shape.cx5 = shape.cx5 * widthScale;
                        shape.cy5 = shape.cy5 * heightScale;
                    }

                    if (updatePath)
                        shape.path = undefined;
                }

                if (shape.type == shapeTypes.FREEHAND) {
                    var points = shape.pathPoints;
                    var j;

                    for (j=0; j<points.length; j++) {
                        points[j].x = points[j].x * widthScale;
                        points[j].y = points[j].y * heightScale;
                    }
                }

                if (shape.type == shapeTypes.GROUP)
                    updateGroupShapesSize(shape, oldW, shape.width, oldH, shape.height);
                break;
            }
        }

        newGroupedShapes.push(shape);
    }

    shapeGroup.shapes = newGroupedShapes;
}

export function updateTransformToolProperties (state, uuid, newWidth, newHeight, x, y, horizontalFlip, verticalFlip, cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5) {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);
            const oldWidth = newShape.width;
            const oldHeight = newShape.height;
            newShape.width = newWidth;
            newShape.height = newHeight;
            newShape.x = x;
            newShape.y = y;

            if (horizontalFlip != undefined)
                newShape.horizontalFlip = horizontalFlip;

            if (verticalFlip != undefined)
                newShape.verticalFlip = verticalFlip;

            if (shape.type == shapeTypes.FREEHAND) {
                newShape.pathPoints = generateNewPathPoints(newShape.pathPoints, oldWidth, newShape.width, oldHeight, newShape.height);
            } else if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                newShape.path = undefined;
            }

            if (cx != undefined && cy != undefined) {
                newShape.cx = cx;
                newShape.cy = cy;

                if (cx1 && cy1) {
                    newShape.cx1 = cx1;
                    newShape.cy1 = cy1;
                }

                if (cx2 && cy2) {
                    newShape.cx2 = cx2;
                    newShape.cy2 = cy2;
                }

                if (cx3 && cy3) {
                    newShape.cx3 = cx3;
                    newShape.cy3 = cy3;
                }

                if (cx4 && cy4) {
                    newShape.cx4 = cx4;
                    newShape.cy4 = cy4;
                }

                if (cx5 && cy5) {
                    newShape.cx5 = cx5;
                    newShape.cy5 = cy5;
                }

                if (newShape.type == shapeTypes.SCREAM_BUBBLE || newShape.type == shapeTypes.SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE)
                    newShape.path = undefined;
            }

            if (newShape.type == shapeTypes.GROUP)
                updateGroupShapesSize(newShape, oldWidth, newWidth, oldHeight, newHeight);

            if (newShape.type === shapeTypes.VIDEO) {
                if (newShape.x < 0)
                    newShape.x = 0;

                if (newShape.x + newShape.width > configuration.CANVAS_WIDTH )
                    newShape.x = configuration.CANVAS_WIDTH - newShape.width;

                if (newShape.y < 0)
                    newShape.y = 0;

                if (newShape.y + newShape.height > configuration.CANVAS_HEIGHT )
                    newShape.y = configuration.CANVAS_HEIGHT - newShape.height;
            }

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            } else {
                if (newShape.animation)
                    setAnimationStartProperties(newShape);
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function updateNonRectangularShape (state, uuid, x1, y1, x2, y2, cx, cy) {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);
            newShape.x1 = x1;
            newShape.y1 = y1;
            newShape.x2 = x2;
            newShape.y2 = y2;

            if (shape.type == shapeTypes.CURVE) {
                newShape.cx = cx;
                newShape.cy = cy;
            }

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            } else {
                if (newShape.animation)
                    setAnimationStartProperties(newShape);
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function changeShapesPosition (state, positions) {
    const newContent = state.model.content.map(shape => {
        if (positions[shape.uuid]) {
            const newShape = Object.assign({}, shape);
            const position = positions[shape.uuid];

            if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                newShape.cx = newShape.cx + (position.x - newShape.x);
                newShape.cy = newShape.cy + (position.y - newShape.y);

                if (newShape.cx1) {
                    newShape.cx1 = newShape.cx1 + (position.x - newShape.x);
                    newShape.cy1 = newShape.cy1 + (position.y - newShape.y);
                }

                if (newShape.cx2) {
                    newShape.cx2 = newShape.cx2 + (position.x - newShape.x);
                    newShape.cy2 = newShape.cy2 + (position.y - newShape.y);
                }

                if (newShape.cx3) {
                    newShape.cx3 = newShape.cx3 + (position.x - newShape.x);
                    newShape.cy3 = newShape.cy3 + (position.y - newShape.y);
                }

                if (newShape.cx4) {
                    newShape.cx4 = newShape.cx4 + (position.x - newShape.x);
                    newShape.cy4 = newShape.cy4 + (position.y - newShape.y);
                }

                if (newShape.cx5) {
                    newShape.cx5 = newShape.cx5 + (position.x - newShape.x);
                    newShape.cy5 = newShape.cy5 + (position.y - newShape.y);
                }
            }

            if (shape.type == shapeTypes.LINE || shape.type == shapeTypes.CURVE) {
                newShape.x1 = position.x1;
                newShape.y1 = position.y1;
                newShape.x2 = position.x2;
                newShape.y2 = position.y2;

                if (shape.type == shapeTypes.CURVE) {
                    newShape.cx = position.cx;
                    newShape.cy = position.cy;
                }
            } else {
                newShape.x = position.x;
                newShape.y = position.y;
            }

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function setAnimationStartProperties(shape) {
    var animationObject = JSON.parse(JSON.stringify(shape.animation));

    if (shape.animation.start_x !== undefined)
        animationObject.start_x = shape.x;

    if (shape.animation.start_y !== undefined)
        animationObject.start_y = shape.y;

    if (shape.animation.start_width !== undefined)
        animationObject.start_width = shape.width;

    if (shape.animation.start_height !== undefined)
        animationObject.start_height = shape.height;

    if (shape.animation.start_x1 !== undefined)
        animationObject.start_x1 = shape.x1;

    if (shape.animation.start_y1 !== undefined)
        animationObject.start_y1 = shape.y1;

    if (shape.animation.start_x2 !== undefined)
        animationObject.start_x2 = shape.x2;

    if (shape.animation.start_y2 !== undefined)
        animationObject.start_y2 = shape.y2;

    if (shape.animation.start_cx !== undefined)
        animationObject.start_cx = shape.cx;

    if (shape.animation.start_cy !== undefined)
        animationObject.start_cy = shape.cy;

    if (shape.animation.start_opacity !== undefined)
        animationObject.start_opacity = shape.opacity;

    if (shape.animation.start_rotation !== undefined)
        animationObject.start_rotation = shape.rotation;

    if (shape.animation.start_cx1 !== undefined)
        animationObject.start_cx1 = shape.cx1;

    if (shape.animation.start_cy1 !== undefined)
        animationObject.start_cy1 = shape.cy1;

    if (shape.animation.start_cx2 !== undefined)
        animationObject.start_cx2 = shape.cx2;

    if (shape.animation.start_cy2 !== undefined)
        animationObject.start_cy2 = shape.cy2;

    if (shape.animation.start_cx3 !== undefined)
        animationObject.start_cx3 = shape.cx3;

    if (shape.animation.start_cy3 !== undefined)
        animationObject.start_cy3 = shape.cy3;

    if (shape.animation.start_cx4 !== undefined)
        animationObject.start_cx4 = shape.cx4;

    if (shape.animation.start_cy4 !== undefined)
        animationObject.start_cy4 = shape.cy4;

    if (shape.animation.start_cx5 !== undefined)
        animationObject.start_cx5 = shape.cx5;

    if (shape.animation.start_cy5 !== undefined)
        animationObject.start_cy5 = shape.cy5;

    shape.animation = animationObject;
}

export function setNewShapePosition (state, uuid, newX, newY) {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                newShape.cx = newShape.cx + (newX - newShape.x);
                newShape.cy = newShape.cy + (newY - newShape.y);

                if (shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE) {
                    if (newShape.cx1 && newShape.cy1) {
                        newShape.cx1 = newShape.cx1 + (newX - newShape.x);
                        newShape.cy1 = newShape.cy1 + (newY - newShape.y);
                    }

                    if (newShape.cx2 && newShape.cy2) {
                        newShape.cx2 = newShape.cx2 + (newX - newShape.x);
                        newShape.cy2 = newShape.cy2 + (newY - newShape.y);
                    }

                    if (newShape.cx3 && newShape.cy3) {
                        newShape.cx3 = newShape.cx3 + (newX - newShape.x);
                        newShape.cy3 = newShape.cy3 + (newY - newShape.y);
                    }

                    if (newShape.cx4 && newShape.cy4) {
                        newShape.cx4 = newShape.cx4 + (newX - newShape.x);
                        newShape.cy4 = newShape.cy4 + (newY - newShape.y);
                    }

                    if (newShape.cx5 && newShape.cy5) {
                        newShape.cx5 = newShape.cx5 + (newX - newShape.x);
                        newShape.cy5 = newShape.cy5 + (newY - newShape.y);
                    }
                }
            }

            var isPositionChanged = (newShape.x != newX || newShape.y != newY);

            newShape.x = newX;
            newShape.y = newY;

            if (newShape.type === shapeTypes.VIDEO) {
                if (newShape.x < 0)
                    newShape.x = 0;

                if (newShape.x + newShape.width > configuration.CANVAS_WIDTH )
                    newShape.x = configuration.CANVAS_WIDTH - newShape.width;

                if (newShape.y < 0)
                    newShape.y = 0;

                if (newShape.y + newShape.height > configuration.CANVAS_HEIGHT )
                    newShape.y = configuration.CANVAS_HEIGHT - newShape.height;
            }

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            } else {
                if (newShape.animation && isPositionChanged)
                    setAnimationStartProperties(newShape);
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function moveShape (state, uuid, offsetX, offsetY) {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                newShape.cx = newShape.cx + offsetX;
                newShape.cy = newShape.cy + offsetY;

                if (newShape.cx1) {
                    newShape.cx1 = newShape.cx1 + offsetX;
                    newShape.cy1 = newShape.cy1 + offsetY;
                }

                if (newShape.cx2) {
                    newShape.cx2 = newShape.cx2 + offsetX;
                    newShape.cy2 = newShape.cy2 + offsetY;
                }

                if (newShape.cx3) {
                    newShape.cx3 = newShape.cx3 + offsetX;
                    newShape.cy3 = newShape.cy3 + offsetY;
                }

                if (newShape.cx4) {
                    newShape.cx4 = newShape.cx4 + offsetX;
                    newShape.cy4 = newShape.cy4 + offsetY;
                }

                if (newShape.cx5) {
                    newShape.cx5 = newShape.cx5 + offsetX;
                    newShape.cy5 = newShape.cy5 + offsetY;
                }
            }

            newShape.x = newShape.x + offsetX;
            newShape.y = newShape.y + offsetY;

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            }

            return newShape;
        }

        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function updateStem(state, uuid, type) {
    var content = getContent(state, uuid);

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            if (type == 'add') {
                var newPoint = bubbleUtils.getNewControlPoint(newShape);

                if (newShape.cx2 == undefined) {
                    newShape.cx2 = newPoint.x;
                    newShape.cy2 = newPoint.y;
                } else
                if (newShape.cx3 == undefined) {
                    newShape.cx3 = newPoint.x;
                    newShape.cy3 = newPoint.y;
                } else
                if (newShape.cx4 == undefined) {
                    newShape.cx4 = newPoint.x;
                    newShape.cy4 = newPoint.y;
                } else
                if (newShape.cx5 == undefined) {
                    newShape.cx5 = newPoint.x;
                    newShape.cy5 = newPoint.y;
                }
            } else
            if (type == 'delete') {
                if (newShape.cx5 != undefined) {
                    newShape.cx5 = undefined;
                    newShape.cx5 = undefined;
                } else
                if (newShape.cx4 != undefined) {
                    newShape.cx5 = undefined;
                    newShape.cx4 = undefined;
                } else
                if (newShape.cx3 != undefined) {
                    newShape.cx3 = undefined;
                    newShape.cx3 = undefined;
                } else
                if (newShape.cx2 != undefined) {
                    newShape.cx2 = undefined;
                    newShape.cx2 = undefined;
                }
            }

            if (newShape.type == shapeTypes.SCREAM_BUBBLE || newShape.type == shapeTypes.SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE)
                newShape.path = undefined;

            return newShape;
        }
        return shape;
    });

    let clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function updateBubbleControlPoint (state, uuid, cx, cy, type = 'controlPoint') {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            switch(type) {
                case 'controlPoint': {
                    newShape.cx = cx;
                    newShape.cy = cy;
                    break;
                }

                case 'controlPoint1': {
                    newShape.cx1 = cx;
                    newShape.cy1 = cy;
                    break;
                }

                case 'controlPoint2': {
                    newShape.cx2 = cx;
                    newShape.cy2 = cy;
                    break;
                }

                case 'controlPoint3': {
                    newShape.cx3 = cx;
                    newShape.cy3 = cy;
                    break;
                }

                case 'controlPoint4': {
                    newShape.cx4 = cx;
                    newShape.cy4 = cy;
                    break;
                }

                case 'controlPoint5': {
                    newShape.cx5 = cx;
                    newShape.cy5 = cy;
                    break;
                }
            }

            if (newShape.type == shapeTypes.SCREAM_BUBBLE || newShape.type == shapeTypes.SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE)
                newShape.path = undefined;

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            } else {
                if (newShape.animation)
                    setAnimationStartProperties(newShape);
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function selectShapesFromArea (state, selection) {
    if (appParameters.getMode() == modeType.PLAYER)
        return;

    const newContent = state.model.content.map(shape => {
        const newShape = Object.assign({}, shape);
            if (selection.indexOf(shape.uuid) > -1) {
                newShape.isSelected = true;
                return newShape;
           } else
                return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel,
        shortcutsTarget: undefined,
        isSlideCommand: false
    });
}

export function selectShape (state, uuid, isNew = false) {
    if (appParameters.getMode() == modeType.PLAYER)
        return;

    if (animationManager.isAnimationMode()) {
        const animationTargets = animationManager.getAllAnimationTargets(false);
        let clonesArray = [];
        let firstClone;

        for (let i = 0; i < animationTargets.length; i++) {
            const newClone = Object.assign({}, animationTargets[i]);

            if (newClone.uuid === uuid)
                newClone.isSelected = true;
            else
                newClone.isSelected = false;

            if (i === 0)
                firstClone = newClone;
            else
                clonesArray.push(newClone);
        }

        animationManager.clone = firstClone;
        animationManager.clonesArray = clonesArray;
    }

    var shortcutsTarget;

    var newContent = state.model.content.map(shape => {
        const newShape = Object.assign({}, shape);

        if (uuid == 'selectAll' || uuid == '' || uuid == 'slideFocus') {
            var selection = false;

            if (uuid == 'selectAll')
                selection = true;

            if (shape.type != shapeTypes.BACKGROUND) {
                newShape.isSelected = selection;
                shortcutsTarget = undefined;

                return newShape;
            } else {
                return shape;
            }
        } else {
            if (uuid == shape.uuid) {
                if (!shape.isSelected) {
                    newShape.isSelected = true;
                }

                if (shape.type == shapeTypes.TEXTBOX || shape.type == shapeTypes.TEXTBOXSIMPLE || shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                    newShape.isNew = isNew;
                }

                shortcutsTarget = newShape;
            } else {
                if (selectionManager.multipleSelection() == true) {
                    return shape;
                } else {
                    if (shape.isSelected)
                        newShape.isSelected = false;
                    else
                        return shape;
                }
            }

            return newShape;
        }
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    var isSlideCommand = false;

    if (uuid == 'slideFocus')
        isSlideCommand = true;

    return Object.assign({}, state, {
        model: newModel,
        shortcutsTarget: shortcutsTarget,
        isSlideCommand: isSlideCommand
    });
}

export function changeInteractionState (state, uuid, newState, moveState = false) {
    if (appParameters.getMode() == modeType.PLAYER)
        return;

    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        const newShape = Object.assign({}, shape);

        if (shape.uuid === uuid) {
            newShape.isInteraction = newState;
            newShape.moveState = moveState;

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            }
        }

        return newShape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function createGroup (state, shapeModel) {
    let groupedShapes = [];
    let i;

    for (i=0; i<shapeModel.shapes.length; i++) {
        groupedShapes[shapeModel.shapes[i].uuid] = true;
    }

    let shapesArray = state.model.content;
    var newContent = [];

    for (i=0; i<shapesArray.length; i++) {
        if (groupedShapes[shapesArray[i].uuid] == true) {
        } else {
            newContent.push(shapesArray[i]);
        }
    }

    newContent.push(shapeModel);

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function ungroup (state, groupModel, shapes) {
    var currentSlideShapes = state.model.content;
    var i;
    var newShapes = [];

    for (i=0; i<currentSlideShapes.length; i++) {
        if (currentSlideShapes[i].uuid != groupModel.uuid)
            newShapes.push(currentSlideShapes[i]);
    }

    newShapes = newShapes.concat(shapes);

    const newModel = Object.assign({}, state.model, {
        content: newShapes
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function createShape (state, shapeModel) {
    let shapesArray = state.model.content;
    shapesArray.push(shapeModel);

    const newModel = Object.assign({}, state.model, {
        content: shapesArray
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function changeVideoProperties (state, property, value) {
    const newContent = state.model.content.map(shape => {
        if (shape.type === shapeTypes.BACKGROUND && shape.isVideo) {
            const newShape = Object.assign({}, shape);

            switch (property) {
                case 'volume': {
                    newShape.volume = value;
                    break;
                }

                case 'inPoint': {
                    newShape.inPoint = value;
                    break;
                }

                case 'outPoint': {
                    newShape.outPoint = value;
                    break;
                }

                case 'all': {
                    newShape.volume = value.volume;
                    newShape.inPoint = value.inPoint;
                    newShape.outPoint = value.outPoint;
                    break;
                }
            }

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function changeBackgroundContent (state, newProperties) {
    const newContent = state.model.content.map(shape => {
        if (shape.type === shapeTypes.BACKGROUND) {
            const newShape = Object.assign({}, shape);

            newShape.contentItemId = newProperties.contentItemId;
            newShape.xlinkHref = newProperties.href;
            newShape.logicalName = newProperties.logicalName;
            newShape.frameLabel = newProperties.frameLabel;
            newShape.moods = newProperties.moods;
            newShape.hotSpot = '';
            newShape.theme = newProperties.theme;

            newShape.isVideo = newProperties.isVideo;
            newShape.volume = newProperties.volume;
            newShape.inPoint = newProperties.inPoint;
            newShape.outPoint = newProperties.outPoint;

            if (newProperties.orgWidth >= 0) {
                newShape.orgWidth = newProperties.orgWidth;
                newShape.orgHeight = newProperties.orgHeight;
            }

            if (newProperties.fill) {
                newShape.fill = newProperties.fill;
                newShape.fillOpacity = newProperties.fillOpacity;
            }

            if (newProperties.stroke) {
                newShape.stroke = newProperties.stroke;
                newShape.strokeOpacity = newProperties.strokeOpacity;
            }

            if (newProperties.frameLabel)
                newShape.frameLabel = newProperties.frameLabel;

            if (newShape.xlinkHref && newShape.xlinkHref.indexOf('file/ci') != -1) { // it's an image or video from myMediaFiles
                newShape.fill = '#000000'; // make bacground black
                newShape.fillOpacity = 1;
            } else {
                newShape.fill = '#ffffff';
            }

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateCurrentSlideThumbnail (state, value) {
    return Object.assign({}, state, {
        updateThumbnail: value
    });
}

function initSlide (state) {
    var slideModel = Object.assign({}, state.model, {
        initialized: true,
        isClone: false
    });

    return Object.assign({}, state, {
        model: slideModel
    });
}

function duplicateGroup (shapeGroup) {
    shapeGroup = Object.assign({}, shapeGroup);
    shapeGroup.uuid = uuid.v4();

    var i;
    var shape;
    var shapes = shapeGroup.shapes;
    var newGroupedShapes = [];

    for (i=0; i<shapes.length; i++) {
        shape = Object.assign({}, shapes[i]);
        shape.uuid = uuid.v4();

        if (shape.type == shapeTypes.GROUP)
            shape = duplicateGroup(shape);

        newGroupedShapes.push(shape);
    }

    shapeGroup.shapes = newGroupedShapes;

    return shapeGroup;
}

function duplicateShape (state, model) {
    let shapesArray = state.model.content;
    var cloneShape = Object.assign({}, model);

    cloneShape.uuid = uuid.v4();
    cloneShape.isNew = true;

    if (cloneShape.type == shapeTypes.GROUP)
        cloneShape = duplicateGroup(cloneShape);

    var offset = 10;

    if (selectionManager.currentSlide != undefined && state.model.uuid != selectionManager.currentSlide.uuid)
        offset = 0;

    if (model.type == shapeTypes.LINE || model.type == shapeTypes.CURVE) {
        cloneShape.x1 = cloneShape.x1 + offset;
        cloneShape.y1 = cloneShape.y1 + offset;
        cloneShape.x2 = cloneShape.x2 + offset;
        cloneShape.y2 = cloneShape.y2 + offset;

        if (model.type == shapeTypes.CURVE) {
            cloneShape.cx = cloneShape.cx + offset;
            cloneShape.cy = cloneShape.cy + offset;
        }
    } else {
        cloneShape.x = cloneShape.x + offset;
        cloneShape.y = cloneShape.y + offset;

        if (cloneShape.cx) {
            cloneShape.cx = cloneShape.cx + offset;
            cloneShape.cy = cloneShape.cy + offset;
        }

        if (cloneShape.cx1) {
            cloneShape.cx1 = cloneShape.cx1 + offset;
            cloneShape.cy1 = cloneShape.cy1 + offset;
        }

        if (cloneShape.cx2) {
            cloneShape.cx2 = cloneShape.cx2 + offset;
            cloneShape.cy2 = cloneShape.cy2 + offset;
        }

        if (cloneShape.cx3) {
            cloneShape.cx3 = cloneShape.cx3 + offset;
            cloneShape.cy3 = cloneShape.cy3 + offset;
        }

        if (cloneShape.cx4) {
            cloneShape.cx4 = cloneShape.cx4 + offset;
            cloneShape.cy4 = cloneShape.cy4 + offset;
        }

        if (cloneShape.cx5) {
            cloneShape.cx5 = cloneShape.cx5 + offset;
            cloneShape.cy5 = cloneShape.cy5 + offset;
        }
    }

    shapesArray.push(cloneShape);

    const newModel = Object.assign({}, state.model, {
        content: shapesArray
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function deleteShape (state, models) {
    var newShapes = [];
    let shapesArray = state.model.content;
    var i;

    for (i=0; i<shapesArray.length; i++) {
        if (models.indexOf(shapesArray[i].uuid) == -1)
            newShapes.push(shapesArray[i]);
    }

    const newModel = Object.assign({}, state.model, {
        content: newShapes
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function addVideoShapeDuration (state, shapeModel, duration) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            newShape.duration = duration;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateVideoShape (state, uuid) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.refresh = new Date().getTime();

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function lockShape (state, shapeModel) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            var lockValue = newShape.isLocked;

            if (lockValue == undefined)
                lockValue = false;

            newShape.isLocked = !lockValue;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function bringToFront (state, shapeModel) {
    const shapes = state.model.content;
    var newShapes = [];
    var firstShapes = [];
    var lastShape;
    var i;
    var shape;

    for (i=0; i<shapes.length; i++) {
        shape = shapes[i];

        if (shape.uuid != shapeModel.uuid)
            firstShapes.push(shape);
        else
            lastShape = shape;
    }

    newShapes = newShapes.concat(firstShapes);
    newShapes.push(lastShape);

    const newModel = Object.assign({}, state.model, {
        content: newShapes
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function sendToBack (state, shapeModel) {
    const shapes = state.model.content;
    var newShapes = [];
    var firstShapes = [];
    var lastShapes = [];
    var i;
    var shape;

    for (i=0; i<shapes.length; i++) {
        shape = shapes[i];

        if (shape.type == shapeTypes.BACKGROUND || shape.uuid == shapeModel.uuid)
            firstShapes.push(shape);
        else
            lastShapes.push(shape);
    }

    newShapes = newShapes.concat(firstShapes);
    newShapes = newShapes.concat(lastShapes);

    const newModel = Object.assign({}, state.model, {
        content: newShapes
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function bringForward (state, shapeModel) {
    const shapes = state.model.content;
    var newShapes = [];
    var i;
    var shape;

    for (i=0; i<shapes.length; i++) {
        shape = shapes[i];

        if (shape.uuid != shapeModel.uuid)
            newShapes.push(shape);
        else {
            if (i + 1 < shapes.length) {
                newShapes.push(shapes[i+1]);
            }

            newShapes.push(shapes[i]);
            i=i+1;
        }
    }

    const newModel = Object.assign({}, state.model, {
        content: newShapes
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function sendBackward (state, shapeModel) {
    const shapes = state.model.content;
    var newShapes = [];
    var lastShapes = [];
    var i;
    var shape;
    var index = -1;

    for (i=0; i<shapes.length; i++) {
        shape = shapes[i];

        if (shape.uuid == shapeModel.uuid) {
            index = i;

            if (index == 1)
                break;
        }

        if (index != -1 && i > index)
            lastShapes.push(shape);
    }

    if (index == 1)
        newShapes = shapes;
    else {
        for (i = 0; i < index - 1; i++) {
            shape = shapes[i];
            newShapes.push(shape);
        }

        newShapes.push(shapes[index]);
        newShapes.push(shapes[index - 1]);
        newShapes = newShapes.concat(lastShapes);
    }

    const newModel = Object.assign({}, state.model, {
        content: newShapes
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeFilter (state, shapeModel, filter) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            newShape.filter = filter;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeSlideDuration (state, duration) {
    const newModel = Object.assign({}, state.model, {
        time: duration
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeAlternativeText (state, text) {
    const newModel = Object.assign({}, state.model, {
        alternativeText: text
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeShapeStrokeOpacity (state, shapeModel, opacity) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            newShape.strokeOpacity = opacity;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeStrokeSize (state, shapeModel, strokeSize) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            if (newShape.type == 'Group') {
                var shapes = newShape.shapes;
                newShape.shapes = [];

                for (var i=0; i<shapes.length; i++) {
                    var shape = Object.assign({}, shapes[i]);

                    shape.strokeWidth = strokeSize;

                    if (shape.strokeOpacity == 0)
                        shape.strokeOpacity = 1;

                    newShape.shapes.push(shape);
                }
            } else {
                newShape.strokeWidth = strokeSize;

                if (newShape.strokeOpacity == 0)
                    newShape.strokeOpacity = 1;
            }

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeShapeFillColor (state, shapeModel, color) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            if (newShape.type == 'Group') {
                var shapes = newShape.shapes;
                newShape.shapes = [];

                for (var i=0; i<shapes.length; i++) {
                    var shape = Object.assign({}, shapes[i]);

                    shape.fill = color;
                    shape.fillOpacity = 1;

                    newShape.shapes.push(shape);
                }
            } else {
                newShape.fill = color;
                newShape.fillOpacity = 1;
            }

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeShapeStrokeColor (state, shapeModel, color) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            if (newShape.type == 'Group') {
                var shapes = newShape.shapes;
                newShape.shapes = [];

                for (var i=0; i<shapes.length; i++) {
                    var shape = Object.assign({}, shapes[i]);

                    shape.stroke = color;

                    if (shape.strokeOpacity == 0)
                        shape.strokeOpacity = 1;

                    newShape.shapes.push(shape);
                }
            } else {
                newShape.stroke = color;

                if (newShape.strokeOpacity == 0)
                    newShape.strokeOpacity = 1;
            }

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeRichTextContent (state, uuid, htmlText) {
    var content = getContent(state, uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.htmlText = htmlText;
            newShape.isRichText = true;

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == uuid)
                    animationManager.target = newShape;
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeTextProperties (state, shapeModel, propertyType, newValue, isRichText = false) {
    var content = getContent(state, shapeModel.uuid);
    let clone;

    var newContent = content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            newShape.useLineHeightTextProperty = true;

            switch (propertyType) {
                case 'fontBold': {
                    newShape.fontBold = newValue;
                    break;
                }
                case 'fontItalic': {
                    newShape.fontItalic = newValue;
                    break;
                }
                case 'fontUnderline': {
                    newShape.fontUnderline = newValue;
                    break;
                }
                case 'fontAlign': {
                    newShape.fontAlign = newValue;
                    break;
                }

                case 'fontColor': {
                    newShape.fontColor = newValue;
                    break;
                }

                case 'htmlText': {
                    newShape.htmlText = newValue;

                    if (isRichText == true)
                        newShape.isRichText = true;
                    break;
                }

                case 'fontFamily': {
                    textEditorUtils.currentFont = newValue;
                    newShape.fontFamily = newValue;
                    break;
                }

                case 'fontSize': {
                    newShape.fontSize = newValue;
                    break;
                }
            }

            if (animationManager.isAnimationMode()) {
                clone = animationManager.getCloneByUid(newShape.uuid);

                if (!clone)
                    clone = animationManager.clone;

                if (clone && newShape.uuid === clone.uuid)
                    animationManager.replaceClone(newShape);

                if (animationManager.target && animationManager.target.uuid == shapeModel.uuid)
                    animationManager.target = newShape;
            }

            return newShape;
        }
        return shape;
    });

    clone = animationManager.getCloneByUid(shapeModel.uuid);

    if (!clone)
        clone = animationManager.clone;

    if (clone && clone.uuid == shapeModel.uuid)
        newContent = state.model.content;

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function setShortcutsTarget (state, isSlideCommand) {
    return Object.assign({}, state, {
        isSlideCommand: isSlideCommand
    });
}

function updateTextProperties (state, shapeModel, propertyType, stepOffset) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === shapeModel.uuid) {
            const newShape = Object.assign({}, shape);

            switch (propertyType) {
                case 'fontBold': {
                    newShape.fontBold = !newShape.fontBold;
                    break;
                }
                case 'fontItalic': {
                    newShape.fontItalic = !newShape.fontItalic;
                    break;
                }
                case 'fontUnderline': {
                    newShape.fontUnderline = !newShape.fontUnderline;
                    break;
                }
                case 'fontSize': {
                    var newSize = newShape.fontSize + stepOffset;
                    if (newSize > 10 && newSize < 60)
                        newShape.fontSize = newSize;
                    break;
                }
            }

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function setCloneTarget (state, shapeModel) {
    return Object.assign({}, state, {
        cloneTarget: shapeModel
    });
}

function canvasUndoRedoAction (state, appState) {
    const newCurrentSlideState = appState.currentSlide;

    return Object.assign({}, state, {
        cloneTarget: undefined,
        model: newCurrentSlideState.model,
        isSlideCommand: false,
        currentSlideIndex: newCurrentSlideState.currentSlideIndex,
        shortcutsTarget: undefined,
        updateThumbnail: false
    });
}

function changeMood (state, uuid, frameLabel) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.frameLabel = frameLabel;
            newShape.xlinkHref = appParameters.SVG_URL() + `${shape.logicalName}_${frameLabel}.svg`;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function selectLastAddedShape (state) {
    if (appParameters.getMode() == modeType.PLAYER)
        return;

    var shortcutsTarget;
    var index = -1;
    var lastIndex = state.model.content.length - 1;

    const newContent = state.model.content.map(shape => {
        index = index + 1;
        const newShape = Object.assign({}, shape);

        if (index === lastIndex) {
            if (!shape.isSelected) {
                newShape.isSelected = true;
            }
            shortcutsTarget = newShape;
        } else {
            if (shape.isSelected)
                newShape.isSelected = false;
            else
                return shape;
        }

        return newShape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel,
        shortcutsTarget: shortcutsTarget,
        isSlideCommand: false
    });
}

function updateImageSize (state, uuid, newWidth, newHeight) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.isNewImage = false;
            newShape.width = newWidth;
            newShape.height = newHeight;

            if (createShapes.dragDropTopLeftPosition) {
                newShape.x = createShapes.dragDropTopLeftPosition.x;
                newShape.y = createShapes.dragDropTopLeftPosition.y;
            } else {
                newShape.x = configuration.CANVAS_WIDTH / 2 - newShape.width / 2;
                newShape.y = configuration.CANVAS_HEIGHT / 2 - newShape.height / 2;
            }

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateImageSizeWhenChangeMood (state, uuid, originalWidth, origianlHeight) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.isNewImage = false;
            newShape.height = newShape.width * (origianlHeight / originalWidth);

            return newShape;
        }

        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function updateImageHeight (state, uuid, newHeight, updateWidth) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.isNewImage = false;

            if (newHeight > 0) {
                if (updateWidth) {
                    newShape.height = newShape.width;
                    newShape.width = newHeight;
                } else {
                    newShape.height = newHeight;
                }

                if (newShape.hasTopLeftPosition == true) {
                    // not change top left position ... it's a drag-and-drop
                } else {
                    newShape.x = configuration.CANVAS_WIDTH / 2 - newShape.width / 2;
                    newShape.y = configuration.CANVAS_HEIGHT / 2 - newShape.height / 2;
                }
            }

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeIsNewShape (state, uuid, isNew) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.isNew = isNew;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeShapeType (state, uuid, type) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.type = type;

            newShape.cx = undefined;
            newShape.cy = undefined;
            newShape.cx1 = undefined;
            newShape.cy1 = undefined;
            newShape.path = undefined;

            createShapes.addControlPointPosition(newShape);

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeTextLineHeight (state, uuid, lineHeight) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.lineHeight = lineHeight;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function oldTextResized (state, uuid) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.oldTextResized = true;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function setSlideSound (state, sound) {
    audioUtils.updateSlideDuration = true;

    var newModel;

    if (sound.href == '') {
        newModel = Object.assign({}, state.model, {
            contentItemId: -1,
            sound: '',
            soundWav: '',
            soundTitle: ''
        });
    } else {
        if (sound.contentItemId == -1) {
            newModel = Object.assign({}, state.model, {
                contentItemId: sound.contentItemId,
                soundTitle: sound.title,
                soundWav: sound.href
            });
        } else {
            newModel = Object.assign({}, state.model, {
                contentItemId: sound.contentItemId,
                soundTitle: sound.title,
                sound: sound.href
            });
        }
    }

    return Object.assign({}, state, {
        model: newModel
    });
}

function setSlideSoundEffect (state, sound) {
    audioUtils.updateSlideDuration = true;

    var newModel;

    if (sound.href == '') {
        newModel = Object.assign({}, state.model, {
            contentItemIdSoundEffect: -1,
            soundEffect: '',
            soundEffectTitle: ''
        });
    } else {
        newModel = Object.assign({}, state.model, {
            contentItemIdSoundEffect: sound.contentItemId,
            soundEffectTitle: sound.title,
            soundEffect: sound.href
        });
    }

    return Object.assign({}, state, {
        model: newModel
    });
}

export function updateTextHeight (state, uuid, newHeight, newWidth) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            if (newShape.type == shapeTypes.SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || newShape.type == shapeTypes.SCREAM_BUBBLE || newShape.type == shapeTypes.THOUGHT_BUBBLE) {
                newShape.path = undefined;

                if (shape.cy > shape.y && !newWidth) {
                    var oldBottomY = shape.y + shape.height;
                    var newBottomY = shape.y + newHeight;
                    var controlPointOffset = shape.cy - oldBottomY;

                    newShape.cy = newBottomY + controlPointOffset;

                    if (newShape.cy1) {
                        controlPointOffset = shape.cy1 - oldBottomY;
                        newShape.cy1 = newBottomY + controlPointOffset;
                    }
                }
            }

            if (newWidth > 0 && newHeight > 0) {
                newShape.width = newWidth;
                newShape.height = newHeight;
            } else
            if (newWidth > 0)
                newShape.width = newWidth;
            else
                newShape.height = newHeight;

            newShape.useLineHeightTextProperty = true;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

function changeShapeFillVisibility (state, uuid, isFillVisible) {
    const newContent = state.model.content.map(shape => {
        if (shape.uuid === uuid) {
            const newShape = Object.assign({}, shape);

            newShape.backgroundVisible = isFillVisible;

            return newShape;
        }
        return shape;
    });

    const newModel = Object.assign({}, state.model, {
        content: newContent
    });

    return Object.assign({}, state, {
        model: newModel
    });
}

export function updateCurrentSlideIndex (state, slideUid) {
    const productionState = storeManager.getState();
    const slides = productionState.production.slides;
    var i;
    var newIndex = 0;

    for (i=0; i<slides.length; i++) {
        if (slides[i].uuid == slideUid) {
            newIndex = i;
            break;
        }
    }

    return Object.assign({}, state, {
        currentSlideIndex: newIndex
    });
}

function changeSlideSoundVolume (state, volume, isSoundEffect) {
    var newModel;

    if (isSoundEffect) {
        newModel = Object.assign({}, state.model, {
            soundEffectVolume: volume
        });
    } else {
        newModel = Object.assign({}, state.model, {
            soundVolume: volume
        });
    }

    return Object.assign({}, state, {
        model: newModel
    });
}

export default function (state = {}, action) {
    switch (action.type) {
        case types.SET_CURRENT_SLIDE: {
            animationManager.updateCurrentTime();

            return Object.assign({}, state, {
                currentSlideIndex: action.currentSlideIndex,
                updateThumbnail: false,
                model: action.currentSlideModel
            });
        }

        case types.UPDATE_CURRENT_SLIDE_INDEX: {
            return updateCurrentSlideIndex(state, action.slideUid);
        }

        case types.UPDATE_SHAPE_POSITION: {
            return setNewShapePosition(state, action.uuid, action.newX, action.newY);
        }

        case types.UPDATE_SHAPE_SIZE: {
            return updateTransformToolProperties(state, action.uuid, action.newWidth, action.newHeight, action.x, action.y, action.horizontalFlip, action.verticalFlip, action.cx, action.cy, action.cx1, action.cy1, action.cx2, action.cy2, action.cx3, action.cy3, action.cx4, action.cy4, action.cx5, action.cy5);
        }

        case types.UPDATE_SHAPE_ROTATION: {
            return updateShapeRotation(state, action.uuid, action.newRotation);
        }

        case types.UPDATE_NON_RECTANGULAR_SHAPE: {
            return updateNonRectangularShape(state, action.uuid, action.x1, action.y1, action.x2, action.y2, action.cx, action.cy);
        }

        case types.UPDATE_BUBBLE_CONTROL_POINT: {
            return updateBubbleControlPoint(state, action.uuid, action.cx, action.cy, action.pointType);
        }

        case types.UPDATE_STEM: {
            return updateStem(state, action.uuid, action.value);
        }

        case types.SELECT_SHAPE: {
            return selectShape(state, action.uuid, action.isNew);
        }

        case types.CHANGE_INTERACTION_STATE: {
            return changeInteractionState(state, action.uuid, action.newState, action.moveState);
        }

        case types.CREATE_SHAPE: {
            return createShape(state, action.shapeModel);
        }

        case types.CHANGE_BACKGROUND_CONTENT: {
            return changeBackgroundContent(state, action.newContent);
        }

        case types.UPDATE_CURRENT_SLIDE_THUMBNAIL: {
            return updateCurrentSlideThumbnail(state, action.value);
        }

        case types.DUPLICATE_SHAPE: {
            return duplicateShape(state, action.model);
        }

        case types.DELETE_SHAPES: {
            return deleteShape(state, action.models);
        }

        case types.LOCK_SHAPE: {
            return lockShape(state, action.shapeModel);
        }

        case types.ADD_VIDEO_SHAPE_DURATION: {
            return addVideoShapeDuration(state, action.shapeModel, action.duration);
        }

        case types.UPDATE_VIDEO_SHAPE: {
            return updateVideoShape(state, action.uuid);
        }

        case types.INIT_SLIDE: {
            return initSlide(state);
        }

        case types.BRING_TO_FRONT: {
            return bringToFront(state, action.shapeModel);
        }

        case types.SEND_TO_BACK: {
            return sendToBack(state, action.shapeModel);
        }

        case types.BRING_FORWARD: {
            return bringForward(state, action.shapeModel);
        }

        case types.SEND_BACKWARD: {
            return sendBackward(state, action.shapeModel);
        }

        case types.CHANGE_FILTER: {
            return changeFilter(state, action.shapeModel, action.filter);
        }

        case types.CHANGE_SLIDE_DURATION: {
            return changeSlideDuration(state, action.duration);
        }

        case types.CHANGE_ALTERNATIVE_TEXT: {
            return changeAlternativeText(state, action.text);
        }

        case types.CHANGE_STROKE_SIZE: {
            return changeStrokeSize(state, action.shapeModel, action.strokeSize);
        }

        case types.CHANGE_SHAPE_OPACITY: {
            return changeShapeOpacity(state, action.shapeModel, action.opacity);
        }

        case types.CHANGE_SHAPE_STROKE_OPACITY: {
            return changeShapeStrokeOpacity(state, action.shapeModel, action.opacity);
        }

        case types.CHANGE_SHAPE_FILL_COLOR: {
            return changeShapeFillColor(state, action.shapeModel, action.color);
        }

        case types.CHANGE_SHAPE_STROKE_COLOR: {
            return changeShapeStrokeColor(state, action.shapeModel, action.color);
        }

        case types.CHANGE_TEXT_PROPERTIES: {
            return changeTextProperties(state, action.shapeModel, action.propertyType, action.newValue, action.isRichText);
        }

        case types.CHANGE_RICH_TEXT_CONTENT: {
            return changeRichTextContent(state, action.uuid, action.value);
        }

        case types.SET_SHORTCUTS_TARGET: {
            return setShortcutsTarget(state, action.isSlideCommand);
        }

        case types.MOVE_SHAPE: {
            return moveShape(state, action.uuid, action.offsetX, action.offsetY);
        }

        case types.UPDATE_TEXT_PROPERTIES: {
            return updateTextProperties(state, action.shapeModel, action.propertyType, action.stepOffset);
        }

        case types.SET_CLONE_TARGET: {
            return setCloneTarget(state, action.shapeModel);
        }

        case types.CANVAS_UNDO_REDO_ACTION: {
            return canvasUndoRedoAction(state, action.newState);
        }

        case types.CHANGE_MOOD: {
            return changeMood(state, action.uuid, action.frameLabel);
        }

        case types.SELECT_LAST_ADDED_SHAPE: {
            return selectLastAddedShape(state);
        }

        case types.UPDATE_TEXT_HEIGHT: {
            return updateTextHeight(state, action.uuid, action.newHeight, action.newWidth);
        }

        case types.CHANGE_SHAPE_FILL_VISIBILITY: {
            return changeShapeFillVisibility(state, action.uuid, action.isFillVisible);
        }

        case types.CHANGE_IS_NEW_SHAPE: {
            return changeIsNewShape(state, action.uuid, action.isNew);
        }

        case types.OLD_TEXT_RESIZED: {
            return oldTextResized(state, action.uuid);
        }

        case types.SET_SLIDE_SOUND: {
            return setSlideSound(state, action.sound);
        }

        case types.SET_SLIDE_SOUND_EFFECT: {
            return setSlideSoundEffect(state, action.sound);
        }

        case types.UPDATE_CURRENT_SLIDE_MOODS: {
            return updateCurrentSlideMoods(state);
        }

        case types.UPDATE_IMAGE_HEIGHT: {
            return updateImageHeight(state, action.uuid, action.newHeight, action.updateWidth);
        }

        case types.UPDATE_IMAGE_SIZE: {
            return updateImageSize(state, action.uuid, action.newWidth, action.newHeight);
        }

        case types.UPDATE_IMAGE_SIZE_WHEN_CHANGE_MOOD: {
            return updateImageSizeWhenChangeMood(state, action.uuid, action.originalWidth, action.originalHeight);
        }

        case types.UPDATE_HOTSPOT: {
            return updateHotspot(state, action.uuid, action.hotspot);
        }

        case types.INSERT_IMAGE_NODE: {
            return insertImageNode(state, action.uuid, action.href, action.aspectRatio);
        }

        case types.UPDATE_CROPPING_HOTSPOT: {
            return updateCroppingHotspot(state, action.uuid, action.hotspot);
        }

        case types.CHANGE_SHAPES_POSITION: {
            return changeShapesPosition(state, action.positions);
        }

        case types.SELECT_SHAPES_FROM_AREA: {
            return selectShapesFromArea(state, action.selection);
        }

        case types.CREATE_GROUP: {
            return createGroup(state, action.groupModel);
        }

        case types.UNGROUP: {
            return ungroup(state, action.groupModel, action.shapes);
        }

        case types.ADD_ANIMATION: {
            return addAnimation(state, action.uuid, action.animation);
        }

        case types.REMOVE_ANIMATION: {
            return removeAnimation(state, action.uuid);
        }

        case types.ANIMATE: {
            return animate(state, action.shapes, action.animations);
        }

        case types.CHANGE_FLIP: {
            return changeFlip(state, action.uuid, action.flipType);
        }

        case types.CHANGE_VIDEO_PROPERTIES: {
            return changeVideoProperties(state, action.property, action.value);
        }

        case types.CHANGE_SLIDE_SOUND_VOLUME:
            return changeSlideSoundVolume(state, action.volume, action.isSoundEffect);

        case types.CHANGE_SHAPE_TYPE:
            return changeShapeType(state, action.uuid, action.value);

        case types.CHANGE_TEXT_LINE_HEIGHT:
            return changeTextLineHeight(state, action.uuid, action.value);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/CurrentSlideReducer.js
 **/